import React, { useState, useEffect } from "react";
import _ from 'lodash';
import { Form, Checkbox, Row, Col, Input } from "antd";

interface props {
  activeQuestion: any;
  form?: any;
}

const MultipleOptionsWithInput: React.FC<props> = (props) => {
  const [selectedAnswers, setSelectedAnswers] = useState<any>(props.form.getFieldValue(props?.activeQuestion?.question) ?? []);
  const [otherValue, setOtherValue] = useState<any>();

  useEffect(() => {
    let dif: any = _.differenceWith(selectedAnswers, props?.activeQuestion?.options, _.isEqual);
    let difVal = dif[0];
    let filteredSelectedAns = selectedAnswers.filter((items?: any) => items !== difVal);

    if (dif?.length) {
      setSelectedAnswers(filteredSelectedAns)
      setOtherValue(difVal)
    }
  }, [])

  useEffect(() => {
    let newAnswerArr = [...selectedAnswers, otherValue];
    if (!_.includes(selectedAnswers, 'Other')) {
      setOtherValue(undefined)
      //   let otherIndexValue: any = _.indexOf(selectedAnswers, 'Other');
      //   newAnswerArr[otherIndexValue] = otherValue
    }
    props.form.setFieldsValue({
      [props?.activeQuestion?.question]: newAnswerArr,
    });
  }, [selectedAnswers, otherValue])


  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-checkbox"
        name={props?.activeQuestion?.question}
        rules={[
          { required: true, message: "You have to select alteast one option" },
        ]}
      >
        <Checkbox.Group
          onChange={(val?: any) => {
            setSelectedAnswers(val)
          }}
          value={selectedAnswers}
        >
          <Row>
            {props?.activeQuestion?.options?.map(
              (option: any, index: any, arr: any) => {
                return (
                  <Col span={24} key={index}>
                    <Checkbox
                      value={option}
                      key={index}
                      onClick={(val?: any) => {
                        // if (index + 1 === arr.length) {
                        //   setInputVisible(true);
                        // } else {
                        //   setInputVisible(false);
                        // }
                      }}
                    >
                      {option}
                    </Checkbox>
                  </Col>
                );
              }
            )}
            <Col span={24}>
              <Input
                className={`${_.includes(selectedAnswers, 'Other') ? "input--option-active" : ""}`}
                placeholder="Please Specify"
                onChange={(e) => {
                  setOtherValue(e.target.value)
                }}
                value={otherValue}
              />
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>
    </div>
  );
};

export default MultipleOptionsWithInput;
